import { logoutKem } from "@ch/redux-store/kem/actions";
import { persistor, store } from "@ch/redux-store/store";
import { logoutUserAction } from "@ch/redux-store/user/actions";
import localforage from "localforage";
import { removeCookie } from "./cookies";
import { StorageNamesEnum } from "./enums";

const logoutUser = () => {
  store?.dispatch(logoutUserAction());
  store?.dispatch(logoutKem());

  void (async () => {
    const hasSeenKemWelcome = await localforage.getItem<boolean>(
      StorageNamesEnum.HAS_SEEN_KEM_WELCOME,
    );

    await localforage.clear();

    if (hasSeenKemWelcome === true) {
      await localforage.setItem(StorageNamesEnum.HAS_SEEN_KEM_WELCOME, true);
    }

    removeCookie(StorageNamesEnum.IS_LOGGED_IN);

    await persistor.purge();
  })();
};

export default logoutUser;
